import React, { useState, useEffect } from 'react';
import { Flex, Button, Avatar, IconButton, useBreakpointValue, Text, Switch, Image, Box, Divider } from '@chakra-ui/react';
import { Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton } from "@chakra-ui/react";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Home2 from '../assets/img/home/home1/home2.png';
import { HamburgerIcon, CloseIcon, ChevronDownIcon } from '@chakra-ui/icons';
import { useDisclosure } from '@chakra-ui/react';
import logofooter from '../../src/assets/img/components/logofooter.png';
import LanguageSwitch from './languageSwitch';
import { useTranslation } from 'react-i18next';


/* --------------------- NAVBAR PRINCIPAL --------------------- */
function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('home');
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { t } = useTranslation();

  const isMobile = useBreakpointValue({ base: true, md: false });

  useEffect(() => {
    if (location.pathname !== '/') return;

    const handleScroll = () => {
      setActiveSection('home');
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  const goHomeTop = () => {
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setActiveSection('home');
    } else {
      navigate('/?section=home');
      setActiveSection('home');
    }
  };

  const routeButtonStyle = (path) => ({
    bg: 'transparent',
    color: location.pathname === path ? '#AE8245' : '#929292',
    fontWeight: location.pathname === path ? 'bold' : 'normal',
    borderRadius: location.pathname === path ? "20px" : 0,
    border: location.pathname === path ? "2px solid #AE8245" : 0,
    _hover: { bg: 'transparent', color: '#d7b363' },
    _active: { transform: 'scale(0.97)' },
    fontFamily: 'Inter',
  });

  const mobileButtonStyle = (path) => ({
    fontSize: "180%",
    fontFamily: 'Roboto Condensed',
    color: location.pathname === path ? "white" : "#FFFFFF8C",
    fontWeight: location.pathname === path ? "bold" : "normal",
    _hover: { fontSize: "200%", transition: "0.2s", color: "white" }
  });

  return (
    <Flex
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={1000}
      bg="#1e1d1d"
      p={4}
      align="center"
      justify="space-between"
    >
      <Flex width={{ md: '60%', lg: '50%' }} gap={{ md: '5%', lg: '5%' }} padding={3} align={'center'} justifyContent={'center'}>
        {/* LOGO */}
        <Avatar as={Link} to="/" src={Home2} alt="Home" onClick={goHomeTop} />

        {/* ---------------- DESKTOP MENU ---------------- */}
        {!isMobile && (
          <Flex gap="3%" >
            <Button onClick={() => navigate('/')} {...routeButtonStyle('/')} fontSize={{ md: '80%', lg: '100%' }} width={{ md: '30%', lg: '100%' }}>{t("nav-item-1")}</Button>
            <Button onClick={() => navigate('/about-us')} {...routeButtonStyle('/about-us')} fontSize={{ md: '80%', lg: '100%' }} width={{ md: '30%', lg: '100%' }}>{t("nav-item-2")}</Button>
            <Button onClick={() => navigate('/services')} {...routeButtonStyle('/services')} fontSize={{ md: '80%', lg: '100%' }} width={{ md: '30%', lg: '100%' }}>{t("nav-item-3")}</Button>
            <Button onClick={() => navigate('/contact')} {...routeButtonStyle('/contact')} fontSize={{ md: '80%', lg: '100%' }} width={{ md: '30%', lg: '100%' }}>{t("nav-item-4")}</Button>
          </Flex>
        )}
      </Flex>

      {/* ---------------- OPCIONES DERECHA (Desktop) ---------------- */}
      <Flex width={{ md: '0%', lg: '50%' }} justify={'right'} align={'center'} mr={{ md: '0%', lg: '5%' }}>
        {!isMobile && (
          <Flex align="center" gap={{ md: 3, lg: 10 }} marginRight="5%">
            <LanguageSwitch />
            <Flex direction={'column'}>
              <Button
                onClick={() => {
                  navigate("/contact#quote-form");
                  onClose();
                }}
                bg="transparent"
                color="white"
                fontFamily='Inter'
                fontSize={{ md: '80%', lg: '100%' }}
                _hover={{ bg: 'transparent', color: '#d7b363' }}
              >
                {t("quote")}
              </Button>
              <Divider width={'70%'} alignSelf={'center'} border={'1px'} />
            </Flex>
          </Flex>
        )}
      </Flex>

      {/* ---------------- MENÚ HAMBURGUESA (MOBILE) ---------------- */}
      {isMobile && (
        <>
          {/* Botón hamburguesa — ahora cambia al abrir */}
          <IconButton
            size="md"
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label="Open Menu"
            bg="transparent"
            color="white"
            onClick={isOpen ? onClose : onOpen}
            display={{ md: "none" }}
          />

          {/* Menú Mobile — ahora se muestra debajo sin mover logo */}
          {isOpen && (
            <Box
              position="absolute"
              top="100%"
              left={0}
              w="100%"
              bg="#1e1d1d"
              pb={6}
              pt={4}
            >
              <Flex direction="column" gap={6} align="center">
                <Image
                  src={logofooter}
                  width={'auto'}
                  mt={{ base: '3%', md: '0' }}
                />

                <LanguageSwitch />

                
                <Button
                  variant="ghost"
                  {...mobileButtonStyle('/')}
                  onClick={() => { navigate('/'); onClose(); }}
                >
                  {t("nav-item-1")}
                </Button>

                <Button
                  variant="ghost"
                  {...mobileButtonStyle('/about-us')}
                  onClick={() => { navigate('/about-us'); onClose(); }}
                >
                  {t("nav-item-2")}
                </Button>

                <Button
                  variant="ghost"
                  {...mobileButtonStyle('/services')}
                  onClick={() => { navigate('/services'); onClose(); }}
                >
                  {t("nav-item-3")}
                </Button>

                <Button
                  variant="ghost"
                  {...mobileButtonStyle('/contact')}
                  onClick={() => { navigate('/contact'); onClose(); }}
                >
                  {t("nav-item-4")}
                </Button>


                <Button
                  width="35%"
                  fontSize="18px"
                  bg="#AE8245"
                  color="white"
                  borderRadius="30px"
                  fontFamily="Inter"
                  _hover={{ fontSize: "200%", transition: "0.2s", color: "white" }}
                  onClick={() => { navigate("/contact#quote-form"); onClose(); }}
                >
                  {t("quote")}
                </Button>
                <Text
                  textAlign="center"
                  fontFamily="Avenir LT Pro"
                  color="#9A9999"
                  fontSize={'100%'}
                  mt="2%"
                >
                  © TMG, All rights reserved, 2025
                </Text>
              </Flex>
            </Box>
          )}
        </>
      )}
    </Flex>
  );
}

export default Navbar;
